import ReactDOM from "react-dom";
import { useEffect, useState } from "react";

const ConfirmationModal = ({
  isOpen = false,
  onConfirm,
  onCancel,
  title = "Confirmation",
  message = "Are you sure you want to proceed?",
  confirmText = "Yes",
  cancelText = "No",
}) => {
  const [animationStep, setAnimationStep] = useState(0);

  // Ensure useEffect is always called in the same order
  useEffect(() => {
    if (!isOpen) return;

    const interval = setInterval(() => {
      setAnimationStep((prev) => (prev + 1) % 3);
    }, 600);

    return () => clearInterval(interval);
  }, [isOpen]);

  // Return null if modal is not open
  if (!isOpen) return null;

  // Modal UI content
  const modalContent = (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.1)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
      }}
    >
      <div
        style={{
          position: "relative",
          width: "100%",
          maxWidth: "400px",
          backgroundColor: "#02111B",
          border: "1px solid #FFC857",
          borderRadius: "8px",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
          padding: "24px",
          outline: "none",
        }}
      >
        <button
          onClick={onCancel}
          style={{
            position: "absolute",
            top: "6px",
            right: "12px",
            color: "white",
            cursor: "pointer",
            background: "none",
            border: "none",
            padding: "0",
            fontSize: "20px",
          }}
        >
          ✕
        </button>

        <div style={{ textAlign: "center" }}>
          <h3 style={{ color: "white", fontSize: "1.5rem", fontWeight: "bold" }}>
            {title}
          </h3>
          <p style={{ color: "white", marginBottom: "24px" }}>{message}</p>

          <div style={{ display: "flex", justifyContent: "center", gap: "16px" }}>
            <button
              onClick={onCancel}
              style={{
                backgroundColor: "transparent",
                color: "white",
                padding: "8px 24px",
                borderRadius: "4px",
                border: "1px solid #FFC857",
                fontWeight: "500",
                cursor: "pointer",
                fontSize: "16px",
              }}
            >
              {cancelText}
            </button>

            <button
              onClick={onConfirm}
              style={{
                backgroundColor: " #BB0A21",
                color: "white",
                padding: "8px 24px",
                borderRadius: "4px",
                border: "none",
                fontWeight: "500",
                cursor: "pointer",
                fontSize: "16px",
              }}
            >
              {confirmText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(modalContent, document.body);
};

export default ConfirmationModal;
